module.exports = __webpack_public_path__ + "fonts/iconfont.b30fdef3.woff2";